import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import React, { useMemo, useEffect, useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import moment from 'moment';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import GroupIcon from '@mui/icons-material/Group';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import toast, { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import ErrorDialog from '../../../components/ErrorDialog';
import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { EncodeToBase64 } from '../../../helpers/tools';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { PopoverModal } from "../../../components/popoverModal/PopoverModal";

export default function TerminosAllList({ rows, setChildrenAction }) {

  const idUsuario = parseInt(sessionStorage.getItem("idUsuario"), 10);

  const path = '/termadmin';

  const navigate = useNavigate();

  const { t } = useTranslation();

  // dlg
  const [open, setOpen] = useState(false);
  const [loadingBorrar, setLoadingBorrar] = useState(false);

  const [termino, setTermino] = useState(null);

  // dlg de error
  const [opendDlgError, setOpenDlgError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");

  useEffect(() => {
    setOpenDlgError(mensajeError !== "");
  }, [mensajeError]);

  const handleEdit = (termino) => {
    navigate(path + '/' + termino.idTermino, { state: { termino: termino, edit: true } });
  };

  const handleView = (termino) => {
    navigate(path + '/' + termino.idTermino, { state: { termino: termino, edit: false } });
  };

  const handleViewUsers = (termino) => {
    navigate('/termusers/' + EncodeToBase64(termino.idTermino.toString()));
  };

  const handleNuevo = () => {
    navigate(path + '/0', { state: { termino: null, edit: true } });
  };

  useEffect(() => {
    setChildrenAction(() =>
    <div>
                <CustomButton
        onClick={handleNuevo}
        title='Agregar nueva versión de Términos y Condiciones'>
         {t("nuevo")}
                </CustomButton>
            </div>
    );
  }, [setChildrenAction]);

  // evalúa si un término está actualmente vigente
  const estaVigente = (vdesde, vhasta, hoy) => hoy >= vdesde && (hoy <= vhasta || vhasta == "");

  const QTerminoEliminar = gql`
        mutation MDeleteTermino ($idTermino: Int!, $idUsuario: Int!) {
            deleteTermino 
            (
                idTermino: $idTermino,
                idUsuario: $idUsuario
            )
            {
                success,
                error,
                valorEsperado
            }
        }`;

  const [deleteTermino, { data }] = useMutation(QTerminoEliminar, {
    onCompleted: (data) => {
      setLoadingBorrar(false);
      if (data.deleteTermino.success) {
        toast.success("Términos y condiciones eliminados correctamente.");
        setOpen(false);
        window.location.replace(path);
        // setTimeout(() => {
        //     window.location.replace(path);
        // }, 1000);
      } else if (data.deleteTermino.error === 'ERRORDB' || parseInt(data.deleteTermino.error, 10) > 0) {
        setMensajeError(data.deleteTermino.error);
      } else {
        setMensajeError(data.deleteTermino.error);
      }
    },
    onError: (data) => {
      setLoadingBorrar(false);
      setMensajeError("ERRORDB");
      return false;
    }
  });

  const handleEliminar = (termino) => {
    setTermino(termino);
    setOpen(true);
  };

  const handleAceptarEliminar = () => {
    setLoadingBorrar(true);
    let result = deleteTermino({ variables: { idTermino: termino.idTermino, idUsuario: idUsuario } });
  };

  const handleCancelarEliminar = () => {
    setOpen(false);
  };

  // permiso de editar: Si el término se encuentra vigente no es posible editarlo
  const permisoEditarEliminar = (row) => {
    // fechas en formato MM/DD/YYYY
    const vigDesde = moment(row.vigenciaDesde).format("yyyy-MM-DD");
    const vigHasta = row.vigenciaHasta != null && row.vigenciaHasta != "" ? moment(row.vigenciaHasta).format("yyyy-MM-DD") : "";
    const hoy = moment().format("yyyy-MM-DD");

    if (!estaVigente(vigDesde, vigHasta, hoy) && (hoy <= vigHasta || vigHasta == "")) {
      return (
        <>
          <div
            onClick={() => handleEdit(row)} aria-hidden='true'
            className="item-option clickable-option"
          >
            <EditIcon className="edit-icon" />
            <span className="toggle-action">Editar</span>
          </div>
          <div
            onClick={() => handleEliminar(row)} aria-hidden='true'
            className="item-option clickable-option"
          >
            <DeleteIcon className="edit-icon" />
            <span className="toggle-action">Eliminar</span>
          </div>
        </>);
    }
  };

  const initialColumns = [
{
      headerName: "",
      field: "action",
      width: 50,
      renderCell: (cellProps) => {
        const { row } = cellProps;
        return (
          <PopoverModal>
            <div className="popover-modal-content">
              <div
                onClick={() => handleView(row)} aria-hidden='true'
                className="item-option clickable-option"
              >
                <VisibilityIcon className="edit-icon" />
                <span className="toggle-action">Ver</span>
              </div>
              <div
                onClick={() => handleViewUsers(row)} aria-hidden='true'
                className="item-option clickable-option"
              >
                <GroupIcon className="edit-icon" />
                <span className="toggle-action">Usuarios que aceptaron</span>
              </div>            
              { permisoEditarEliminar(row) }
            </div>
          </PopoverModal>
        );
      },
    },
  { 
    field: 'version',
    headerName: t("grilla.version"),
    width: 100
  },
  { 
    field: 'vigenciaDesde', 
    type: 'date', 
    time: false, 
    headerName: t("grilla.vigenciaDesde"), 
    width: 150 
  },
  { 
    field: 'vigenciaHasta', 
    type: 'date', 
    time: false, 
    headerName: t("grilla.vigenciaHasta"), 
    width: 150  
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), []);

  const handleCloseDlgError = () => {
    setOpenDlgError(false);
  };

  return (
    <>
            <DataGridGenerico
        columns={columns}
        fileNameExport='Terminos'
        rows={rows}
        toolbar={false} />
      
            <CustomDialog
        maxWidth="md"
        open={open}
        title={`Eliminación de Términos y condiciones - Version # ${termino != null ? termino.version : ""}`}
        onAccept={handleAceptarEliminar}
        acceptLoading={loadingBorrar}
        onCancel={handleCancelarEliminar}>
        
                ¿<strong>Confirma que desea eliminar</strong> los Términos y Condiciones seleccionados?.<br /><br />
                Si <strong>acepta eliminarlos</strong> se procederá a <strong>adecuar las vigencias</strong> de las demás versiones configuradas.
            </CustomDialog>
            <ErrorDialog
        id="dlg-error-terminos"
        open={opendDlgError}
        onClose={handleCloseDlgError}
        mensaje={mensajeError} />
      
        </>);

}